"use client";
import React from "react";
import { usePathname } from "next/navigation";
import "./components.css";
import { Col, Container, Row } from "react-bootstrap";
import CommonButton from "./CommonButton";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import { Left, Right } from "./svg";
import { TestimonialData } from "../../utils/libs/utils";

const TestimonialCard = ({ text, name, location }) => (
  <div className="keen-slider__slide">
    <div className="testimonial-card">
      <p>
        <span>&ldquo;</span>
        {text}
      </p>
      <div>
        <p className="p-0 m-0">
          <b>{name}</b>
        </p>
        <p className="p-0 m-0">{location}</p>
      </div>
    </div>
  </div>
);

const Testimonials = () => {
  const pathname = usePathname();
  const isHomePage = pathname === "/";
  const [sliderRef, instanceRef] = useKeenSlider({
    slides: {
      perView: 1,
      spacing: 30,
    },
  });
  return (
    <div className="testimonials-main">
      <Container>
        <Row>
          <Col xl={6} lg={5} md={12} className="p-lg-5">
            <div
              className={`com-pill mb-4 ${
                isHomePage ? "reveal fade-bottom" : ""
              }`}
            >
              Testimonials ~
            </div>
            <h3
              className={`com-title mb-3 ${
                isHomePage ? "reveal fade-bottom" : ""
              }`}
            >
              Here’s what our <span>customers </span> have said.
            </h3>
            <p className={`mb-4 ${isHomePage ? "reveal fade-bottom" : ""}`}>
              Simplified IT is designed to help make sure you and your data are
              protected and your computer runs it’s best. The network Access
              provides is valuable.
            </p>
          </Col>
          <Col
            xl={6}
            lg={7}
            md={12}
            className={`${isHomePage ? "reveal fade-bottom" : ""}`}
          >
            <div
              ref={sliderRef}
              className="keen-slider testimonial-keen-slider testimonial-keen-slider-responsive"
            >
              {TestimonialData.map((item, index) => (
                <TestimonialCard
                  key={index}
                  text={item.text}
                  name={item.name}
                  location={item.location}
                />
              ))}
            </div>
            <div className="d-flex justify-content-end gap-2 align-items-center">
              <button
                className="slider-nav prev"
                aria-label="Previous Slide"
                onClick={() => instanceRef.current?.prev()}
              >
                <Left />
              </button>
              <button
                className="slider-nav next"
                aria-label="Next Slide"
                onClick={() => instanceRef.current?.next()}
              >
                <Right />
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Testimonials;
